import { BASE_URL } from "../../util/Constants";
import HTTP from "../../util/Http";

var CURSOS = null;
var CURSO_ACTIVO = null;

async function cargarCursoActivo() {
  const url = BASE_URL + "cursos";
  await HTTP.get(url).then((response) => { 
    CURSOS = response.data;
    CURSO_ACTIVO = CURSOS.find(x => x.activado == true);
  });
}

export {CURSO_ACTIVO, cargarCursoActivo};
